import { Action } from '../../../shared/xs/actions';

export class GetAssessmentListAction implements Action {
  static readonly type = '[Scoring] Get list';
}
